<template>
  <div class="holeHeader">
      <b-container>
          <b-row>
            <b-col cols="4">
                <div class="headerAction left">
                    <div class="actionItem">
                        <a 
                            v-if="back"
                            @click.prevent="backBtn" 
                            href="" 
                            class="backBtn mr-3">
                            <b-icon icon="chevron-left"></b-icon>
                        </a>
                    </div>

                    <div class="holesLogo logoleft">
                        <img src="@/assets/logo.svg" alt="Holes" class="img-fluid">
                    </div>
                </div>
            </b-col>
            
            <b-col cols="4">
                <div class="holesLogo logocenter">
                    <img src="@/assets/logo.svg" alt="Holes" class="img-fluid">
                    
                </div>
            </b-col>

            <b-col cols="4">
                <div class="headerAction right">
                    <div 
                        v-on-clickaway="hidenotiftray"
                        class="actionItem">
                        <a 
                            @click.prevent="shownotif = !shownotif"
                            href="" 
                            class="notificationBell">
                            <b-icon icon="bell"></b-icon>

                            <template v-if="unreadnotifs.length > 0">
                                <span class="hasunread"></span>
                            </template>
                        </a>

                        <notification-list 
                        :show.sync="shownotif"
                        v-show="shownotif"/>
                    </div>

                    <div 
                        data-clickaway="profile"
                        @click="$emit('update:menuopen', !menuopen)"
                        class="actionItem">

                        <template v-if="user && user.avatar_url">
                             <div 
                                class="holeProfile" 
                                :style="`background-image:url(${user.avatar_url});`">
                            </div>
                        </template>

                        <template v-else>
                            <div class="holeProfile">
                                <b-icon icon="person-circle"></b-icon>
                            </div>
                        </template>
                       
                    </div>
                </div>
            </b-col>
        </b-row>
      </b-container>
  </div>
</template>

<script>
/**
 * Declerations
 */
// Components
import notificationlist from '@/components/notifications'

//plugins
import { directive as onClickaway } from 'vue-clickaway'


export default {
    props : {
        /**
         * Side menu open state
         */
        menuopen : {
            type : Boolean,
            default : () => {
                return false;
            }
        }
    },
    directives: {
        onClickaway: onClickaway,
    },
    components : {
        'notification-list': notificationlist
    },  
    data() {
        return { 
            shownotif : false,
        }
    },
    methods : {
        /**
         * Hide notif tray
         */
        hidenotiftray() {
            this.shownotif = false
        },
        /**
         * Returning route by 1
         */
        backBtn() {
            this.$router.go(-1);
        }
    },
    computed : {
        /**
         * Unreadnotifs
         */
        unreadnotifs() {
            return this.$store.state.unreadnotifs
        },
        /**
         * Logged in user
         */
        user() {
            return this.$store.state.user
        },
        /**
         * Check visibility of back button for employee
         */
        back() {
            if(this.$route.meta && this.$route.meta.type && this.$route.meta.type.includes('driver')) {
                let show = false;
                switch (this.$route.name) {
                    case 'order':
                        show =  true
                        break;
                    
                }
                
                return show
            } else {
                return false
            }
        }
    }
}
</script>

<style lang="scss">

@import '@/scss/partials/_colors.scss';
@import '@/scss/partials/_mixins.scss';

.holeHeader {
    padding-top   : 15px;
    padding-bottom: 15px;

    @include screen-min(lg) {
        position        : sticky;
        top             : 0;
        background-color: #fff;
        z-index         : 500;

    }

    .holesLogo {
        display        : flex;
        align-items    : center;
        justify-content: center;
        height         : 100%;

        &.logocenter {
            @include screen-min(lg) {
                display: none;
            }
        }

        &.logoleft {
            display: none;

            @include screen-min(lg){
                display: flex;
            }
        }
    }

    .headerAction {
        display: flex;


        &.right {
            justify-content: flex-end;
            padding-right  : 15px;

            .actionItem {
                margin-left : 15px;
            }
        }

        .actionItem {
            align-items: center;
            display    : flex;
            cursor     : pointer;
            position: relative;

            .notificationBell, .backBtn {
                .b-icon.bi {
                    font-size : 25px;
                }

                
            }

            .notificationBell {
                position : relative;

                .hasunread {
                    display         : block;
                    position        : absolute;
                    top             : -5px;
                    right           : -5px;
                    width           : 10px;
                    height          : 10px;
                    border-radius   : 100%;
                    background-color: $primaryColor;
                }
            }

            .holeProfile {
                width              : 30px;
                height             : 30px;
                border-radius      : 100%;
                overflow           : hidden;
                background-size    : cover;
                background-position: center;
                display            : flex;
                align-items        : center;
                justify-content    : center;
                font-size          : 27px;
                color              : $grey;
            }
        }
    }
}
</style>